import { connect } from "react-redux";
import moment from "moment";

import {
  setAuthErrorType,
  setErrors,
  changeForm,
  init
} from "redux/modules/answer/answerLogin";

import Login from "components/answer/Login";
import { setAnswerToken } from "redux/modules/answer/answerHeader";
import { setLoginDt } from "redux/modules/answer/answerResult";

import api from "api";
import { openErrorDialog } from "redux/modules/errorDialog";
import history from "utils/history";
import storage from "utils/storage";

const mapStateToProps = state => ({
  ...state.answerLogin
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  authLogin: () => {
    const { urlToken, id } = ownProps.match.params;
    // エラー時に戻ってこれるようにurlTokenを保存する
    storage.setUrlToken(urlToken);
    if (id) {
      storage.setSurveyId(id);
    }
    api
      .get((id ? `login_page/${id}/${urlToken}/` : `auth_survey_login/${urlToken}`))
      .then(res => {
        // システムエラー
        if (res.invalidStatusError) {
          dispatch(setAuthErrorType("stateNotOpen"));
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeForm: (key, value) => dispatch(changeForm(key, value)),
  handleLogin: password => {
    dispatch(setErrors([]));

    var id;
    const { urlToken } = ownProps.match.params;
    if (storage.getSurveyId()) {
      id = storage.getSurveyId();
    }
    const params = { urlToken, password, id };

    api
      .post("login", params)
      .then(res => {
        // システムエラー
        if (res.invalidStatusError) {
          dispatch(setAuthErrorType("stateNotOpen"));

          // パスワード不正
        } else if (res.errors) {
          dispatch(setErrors(res.errors));

          // 成功
        } else {
          dispatch(setLoginDt(moment()));
          dispatch(setAnswerToken(res.token));
          history.push("/start", ownProps);
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  init: () => {
    dispatch(init());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/answer/SurveyLoginContainer.js